var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDvhc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 183.39 123.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#6e63fb;}.cls-3{fill:#ff6640;}.cls-4{fill:#dc1101;}.cls-5{fill:#ec2910;}.cls-40,.cls-42,.cls-45,.cls-47,.cls-6,.cls-7,.cls-8,.cls-9{opacity:0.3;}.cls-6,.cls-7,.cls-8,.cls-9{mix-blend-mode:screen;}.cls-6{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-2);}.cls-9{fill:url(#linear-gradient-3);}.cls-10{opacity:0.2;}.cls-11,.cls-37,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48{mix-blend-mode:multiply;}.cls-12,.cls-35{fill:#fff;}.cls-12{opacity:0;}.cls-13{fill:#fcf4f3;opacity:0.05;}.cls-14{fill:#fae8e7;opacity:0.1;}.cls-15{fill:#f7dddb;opacity:0.14;}.cls-16{fill:#f4d1ce;opacity:0.19;}.cls-17{fill:#f1c6c2;opacity:0.24;}.cls-18{fill:#efbab6;opacity:0.29;}.cls-19{fill:#ecafaa;opacity:0.33;}.cls-20{fill:#e9a39e;opacity:0.38;}.cls-21{fill:#e79892;opacity:0.43;}.cls-22{fill:#e48c86;opacity:0.48;}.cls-23{fill:#e18179;opacity:0.52;}.cls-24{fill:#de756d;opacity:0.57;}.cls-25{fill:#dc6a61;opacity:0.62;}.cls-26{fill:#d95e55;opacity:0.67;}.cls-27{fill:#d65349;opacity:0.71;}.cls-28{fill:#d4473d;opacity:0.76;}.cls-29{fill:#d13c31;opacity:0.81;}.cls-30{fill:#ce3024;opacity:0.86;}.cls-31{fill:#cb2518;opacity:0.9;}.cls-32{fill:#c9190c;opacity:0.95;}.cls-33{fill:#c60e00;}.cls-34{fill:#2f2bb2;}.cls-36{fill:#5552e2;}.cls-37,.cls-41,.cls-43,.cls-44,.cls-46,.cls-48{opacity:0.5;}.cls-38{fill:#740201;}.cls-39{fill:#3f3d55;}.cls-40{fill:url(#linear-gradient-4);}.cls-41{fill:url(#linear-gradient-5);}.cls-42{fill:url(#linear-gradient-6);}.cls-43{fill:url(#linear-gradient-7);}.cls-44{fill:url(#linear-gradient-8);}.cls-45{fill:url(#linear-gradient-9);}.cls-46{fill:url(#linear-gradient-10);}.cls-47{fill:url(#linear-gradient-11);}.cls-48{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1023.5,
    y1: 125.9,
    x2: 1023.5,
    y2: 237.22,
    gradientTransform: "matrix(1, 0, 0, 1, -924.29, -122.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d1361e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#882314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4d140b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#230905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0a0201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1030.02,
    y1: 126.21,
    x2: 1030.02,
    y2: 238.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1039.02,
    y1: 125.48,
    x2: 1039.02,
    y2: 239.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -452.85,
    y1: 161.53,
    x2: -451.96,
    y2: 160.48,
    gradientTransform: "matrix(-1, 0, 0, 1, -271.8, -122.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#840301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a34342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c48584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ddbab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f0dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fbf7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -453.1,
    y1: 158.68,
    x2: -451.13,
    y2: 160.71,
    gradientTransform: "matrix(-1, 0, 0, 1, -271.8, -122.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#840301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#a34342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c48584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ddbab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f0dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fbf7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -488.39,
    y1: 165.84,
    x2: -487.51,
    y2: 164.79,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -314.66, -63.52)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -488.64,
    y1: 162.99,
    x2: -486.68,
    y2: 165.02,
    gradientTransform: "matrix(-1, 0.05, 0.05, 1, -314.66, -63.52)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 182.2,
    y1: -374.09,
    x2: 183.08,
    y2: -374.11,
    gradientTransform: "matrix(0, 1, -1, 0, -374.01, -158.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#043a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#426ba2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#849fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#b9c8dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#dfe6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f6f8fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 789.42,
    y1: 234.71,
    x2: 790.52,
    y2: 233.4,
    gradientTransform: "translate(-685.6 -122.81) rotate(0.01)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 789.18,
    y1: 231.25,
    x2: 791.51,
    y2: 233.66,
    gradientTransform: "translate(-685.6 -122.81) rotate(0.01)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 789.46,
    y1: 205.23,
    x2: 790.53,
    y2: 203.96,
    gradientTransform: "translate(-685.6 -122.81) rotate(0.01)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 789.14,
    y1: 201.78,
    x2: 791.53,
    y2: 204.25,
    gradientTransform: "translate(-685.6 -122.81) rotate(0.01)",
    xlinkHref: "#linear-gradient-5"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.4 115.86 171.04 111.73 181.49 110.68 181.4 115.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M314.88,244.92l1.28-.14a.6.6,0,0,0,.45-.57l.57-6.45-5.2.37,2.5,6.5A.39.39,0,0,0,314.88,244.92Z",
    transform: "translate(-182.96 -122.77)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.2 123.74 116.37 117.21 104.66 118.39 105.2 123.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.55,242.05l-1.17.13c-.21,0-.38-.17-.41-.45l-.53-6.08,4.73-.62-2.25,6.66A.48.48,0,0,1,340.55,242.05Z",
    transform: "translate(-182.96 -122.77)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.29 112.63 97.35 112.53 97.21 2.56 98.15 2.46 98.29 112.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "100.88 112.9 101.84 113 101.7 2.07 100.74 2.17 100.88 112.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "98.29 112.63 100.88 112.9 100.74 2.17 98.15 2.46 98.29 112.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.29 112.63 100.88 112.9 100.74 2.17 98.15 2.46 98.29 112.63"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 3,
    height: 112,
    transform: "translate(99.04 1.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABwCAYAAADbnsrQAAAACXBIWXMAAAsSAAALEgHS3X78AAABP0lEQVQ4T42TyU7DQBBEazbbKAiChPj/L0PiwqKIiD0ksV0cjN3VVoyYk59qpnq6XQOSAECSiJD1DwghMAJAjMGUVdMYlJwMmlIZhCBn3LaSBK7XFwYxRIMqZ4OUlpSsbu6iTqlLMbg6Xxkk3Zaj1Dl2ncFZJc01tUDSM1Hb9opC8rB0xt3NTdTVmdoOIdAN8fQ2YFYHum34/IWb9aVBpUOsS1YQpej/uX14FANVKjWoshjMlKUzrrm7p42By5szcHdzCoElZXhDA9w/b8XNZUeLTuEjGVwSxxUBoO97A2ed/oiLgEvVuCIAdJreVutsXt7UYClVLm9uBq1au1firF2QxnViBmp9bFsFtX4V657SD3sxIAQ+v/cGXwq7w0Hc1GCmaB296Pb9w8ANZLcXg9ENJJFiJACOTgTAaSAkww/XQnnqEcqqHgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 3,
    height: 111,
    transform: "translate(97.04 2.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABvCAYAAAApHnqeAAAACXBIWXMAAAsSAAALEgHS3X78AAABOUlEQVQ4T3WUS07EMBBE223nM5kBBBqxQOIQLLgDp+YKLDgGC8RnpCS206yGrhrJvcpTdao/diJBxETEzEx0HHo5h+56hGFwmDBtxLQuRYeo6jD0HUDXgpv93qFLYBBCcOhTwjQAUq73k0PSlluMoKQII3QICYc7jDsHVXATCH19e3d4eX5yoDq0qmmEXQsEAxWNAQxUCTANFVqViQe8cbkqRQhNoDRqRyAwS/Tz5+SQaxERkRCCaS4VlFIQQDHzIfTx/uiw5OywZjBgBa0p7fxgZkEfjneuLCsYzOhGCtWhEWjx27Y53F4dHGZyW1dQ2Lq1kIrWVIe+4JmssWiuLeuCSqlgXbeWQjug3ggKzvPx9e1AV5m6pl3TTTwtiwMdMIxz4UaT/s6zQ/voBYLSRPB3a2b/zbU/9D/G4qXgIfGJ/QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "104.37 114.34 103.09 114.24 102.9 2.87 104.19 2.77 104.37 114.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.89 114.62 109.19 114.72 109 2.37 107.7 2.47 107.89 114.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "104.37 114.34 107.89 114.62 107.7 2.47 104.19 2.77 104.37 114.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "104.37 114.34 107.89 114.62 107.7 2.47 104.19 2.77 104.37 114.34"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 3,
    height: 113,
    transform: "translate(106.04 2.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABxCAYAAAAQwhl1AAAACXBIWXMAAAsSAAALEgHS3X78AAABfklEQVQ4T3WU207DMBBEZ504SYsKSEgInvn/70KAql6gKuSyw0Ni77pq83Y0693xrBWQBACSRID7MogIAwB0TWNK18SyLMO6bQ2qKhg83W8MgiyKiLCNtSnFHAgMVl6pq8og1g666LyJiDvjy95eX2aIdYXP/WGGIAGb9SqV0YaSQNcmB+LsNHVtrkmaHdI5IIn9z2kB0EL87Qdr0DWxjNcFImjqJSoBsD1+z3C3avH8+DCDEggh2NDT+WzQpm6qtKhmJaYGLF2L30LwicpN6IfRoPUryZtLOQNAUFWbo/OzdMryEGYllyltjlLRpIdEXBhN/eZYlvbXlAQECF/mzyQLpdLE2kBVoQZ0CmkKAEzTlIBADh6AqlpZTKtXpV2OcMty568o6QsE8L7dLeCzBty1SVogell2G3JrAFCqB3dt1VvxFmWF8rHbG4yWGzD5qMbJQY6XpIy+rGidfwEAMIyjh8mDU/qbStH663A0+BsGB72H4QqkTgTAnDVJ+QcRme/mQjIbnQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 3,
    height: 113,
    transform: "translate(103.04 2.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABxCAYAAAAQwhl1AAAACXBIWXMAAAsSAAALEgHS3X78AAABs0lEQVQ4T3WUS4/UQAyEy04y2cwMGiGWh0CIA///B3EECWkRQrPaHVDSL3NIOuU+rG+fyq6uxJ3AzADAzAwqIoat9HI6YodpPBCO40i4Oxw8DAS40nFwyujbXp/PhMPQE4begQoIfeeUQ9+9MHM5nfzMmkhETDtlPIXQW4fOufVdY+3g1TQRfDgV7/b912/C148fCE2Cmg0A9Oyt4aoF9z6g6t1UBdO2lvYcFQW2wXanxYwAVyqyj0BVBJ/u31RF8HB9JNSzVEXWQQA6dD1qPi1m6Lbsug4qz9nbALBNIE4R0FrQzLgEbglQPhqg16cbYUmREGLCn6fnTYlxv3QaYmLQ83THbJfTkUozM8fIoEuIDLrERCVEl+Dzu3vUsBpSAra16BIilTm4mTlGPN7+1rYA2Q/15wCgkkshlFLYNo0jlTkEKnOIvDtLjPjy/m21Nnz78XOFlAvbci6QjTSVvH9pmnNBfQzNpaCWLjGiOqiZcSblzLboIaXMO7q2Cduut3Xjen12q29eIlzpHAKhOTTlNaiZyRZ0U5qv8d/iDG7zTGi2bf5eAjDUH7GZ7YYv/wL+AyeFteTGx34VAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "113.33 115.04 112.01 114.94 111.82 2.13 113.14 2.02 113.33 115.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "116.93 115.32 118.27 115.42 118.08 1.61 116.74 1.73 116.93 115.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "113.33 115.04 116.93 115.32 116.74 1.73 113.14 2.02 113.33 115.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "113.33 115.04 116.93 115.32 116.74 1.73 113.14 2.02 113.33 115.04"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 3,
    height: 115,
    transform: "translate(115.04 1.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABzCAYAAABdCrh+AAAACXBIWXMAAAsSAAALEgHS3X78AAABf0lEQVQ4T4WUzU7DMBCEZ23np0XlgIQ48v6PhhBQaCvaJPVwcOzdBVXk9mnWs+vZJCAJACSJAPM0EBEGANgOvSrbYfBlDR7udwpD15kzozkTRExZb8rGfu0jIlyrinI3jAq77UahS0nBndn0ZuqNvYJTpI4TQ0CMUZWuAkGkppTYqmKm7lPEqH3E3zSGklgQEQWAiHGF8zSrMvYdYmjjCLpkZlM3/Eo0BAe1jwBBgiqxlnUxahkJPD89FsgkXvefVaHP2oPLzSp9uqW4qV9qnz9uGrwY6GJUyJlIab1CZrabAwSmT9nbCu9fB4W2BQBILXj+VuxsYt2a9bQsyDkXIImP40nL2uYImmURfj/uVV6/1QLXag0Ab1/HG2dcvC6DOnbIJHJ21leF5Wr6fBxMn/r8A9lOPS+LBdNnvhr4PJmoaGdzbi6QyVpP8wokxSl7u4XFNnWJOuvLvFiYb8FkYG+vsNibEsb6bM+cL9MN5XsqCkiiT4nFh+0vxBY8SfkBrHyyFoIi/hQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-7",
    width: 3,
    height: 114,
    transform: "translate(112.04 1.23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAByCAYAAACWVmvbAAAACXBIWXMAAAsSAAALEgHS3X78AAABkUlEQVQ4T42US27cQAxEq6mRZjzJ+Ac4Wfoi3uQWOW2ukEU2XhswDBgw/MnHUrealYXUQ/ZgBJi7p6Kq2SQlkAQAkoScrDtiDtm0HQy61mDdLSkbrzQSDC53O4O2XRl0q8aDU1oPq0YMKremcQZVWiMOVj6tUiRMhYYQKFfnp6aEcCRtAn+5SgmL8OPnL4Pv324W0uDio1AZVI2/8K2ap30MQJRRigQBMJlIVkVxFwkBxXw+dE47+7Q1N/XWqurBKz4NLnxDD5Td9gRfLs4myFn3uZJVUeYqY86QApUBATw8Pc8KiTJKIexk2XSdGYzjaEry1iScAWlpJK0cPVT2BiLBlDiOKCEkUPojqorHl9cjbqqKYD1YVOjB901JG/DT229T+hjtnSEmg0rpY8L11ytzu727n+By99nWpT80ePnz16CE9DHZtfsYkeam1OuSs9uqlLNB9QvoY/IQF6Bay3/DYJD99sY0lUIyyJCctSsN8u4NCGf9PrhDR3cFbNdrovyIR3cfYFqDSfFPheT+O/kPk77VG9r4X7QAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "135.76 118.75 133.04 118.53 130.31 118.31 127.59 118.09 127.58 110.92 130.92 113.82 132.67 116.79 135.76 117.04 135.76 118.75"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "126.23 117.98 123.58 117.76 120.92 117.55 118.27 117.33 118.26 110.27 121.51 113.12 123.22 116.06 126.23 116.29 126.23 117.98"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "116.94 117.23 114.36 117.02 111.77 116.81 109.19 116.6 109.17 109.63 112.34 112.44 114.01 115.33 116.94 115.56 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "116.94 117.23 114.33 117.02 111.75 116.81 109.19 116.6 109.17 109.7 112.33 112.51 113.97 115.36 116.94 115.6 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "116.94 117.23 114.29 117.01 111.73 116.81 109.19 116.6 109.17 109.77 112.31 112.58 113.94 115.4 116.94 115.63 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "116.94 117.23 114.26 117.01 111.72 116.81 109.19 116.6 109.18 109.85 112.3 112.66 113.91 115.43 116.94 115.66 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "116.94 117.23 114.23 117.01 111.7 116.81 109.19 116.6 109.18 109.92 112.28 112.73 113.88 115.46 116.94 115.7 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "116.94 117.23 114.19 117.01 111.68 116.8 109.19 116.6 109.18 110 112.26 112.8 113.85 115.49 116.94 115.73 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "116.94 117.23 114.16 117 111.66 116.8 109.19 116.6 109.18 110.07 112.25 112.88 113.82 115.52 116.94 115.77 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "116.94 117.23 114.13 117 111.65 116.8 109.19 116.6 109.18 110.14 112.23 112.95 113.79 115.55 116.94 115.8 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "116.94 117.23 114.09 117 111.63 116.8 109.19 116.6 109.18 110.22 112.22 113.02 113.75 115.58 116.94 115.83 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "116.94 117.23 114.06 117 111.61 116.8 109.19 116.6 109.18 110.29 112.2 113.1 113.72 115.61 116.94 115.87 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "116.94 117.23 114.02 116.99 111.6 116.8 109.19 116.6 109.18 110.37 112.19 113.17 113.69 115.64 116.94 115.9 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "116.94 117.23 113.99 116.99 111.58 116.8 109.19 116.6 109.18 110.44 112.17 113.24 113.66 115.67 116.94 115.93 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "116.94 117.23 113.96 116.99 111.56 116.79 109.19 116.6 109.18 110.52 112.16 113.32 113.63 115.71 116.94 115.97 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "116.94 117.23 113.92 116.98 111.55 116.79 109.19 116.6 109.18 110.59 112.14 113.39 113.6 115.74 116.94 116 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "116.94 117.23 113.89 116.98 111.53 116.79 109.19 116.6 109.18 110.66 112.12 113.46 113.57 115.77 116.94 116.03 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "116.94 117.23 113.85 116.98 111.51 116.79 109.19 116.6 109.18 110.74 112.11 113.54 113.53 115.8 116.94 116.07 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "116.94 117.23 113.82 116.98 111.5 116.79 109.19 116.6 109.18 110.81 112.09 113.61 113.5 115.83 116.94 116.1 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "116.94 117.23 113.79 116.97 111.48 116.79 109.19 116.6 109.18 110.89 112.08 113.68 113.47 115.86 116.94 116.14 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "116.94 117.23 113.75 116.97 111.46 116.79 109.19 116.6 109.18 110.96 112.06 113.76 113.44 115.89 116.94 116.17 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "116.94 117.23 113.72 116.97 111.45 116.78 109.19 116.6 109.18 111.03 112.05 113.83 113.41 115.92 116.94 116.2 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "116.94 117.23 113.69 116.97 111.43 116.78 109.19 116.6 109.18 111.11 112.03 113.91 113.38 115.95 116.94 116.24 116.94 117.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "116.94 117.23 113.65 116.96 111.41 116.78 109.19 116.6 109.18 111.18 112.01 113.98 113.35 115.98 116.94 116.27 116.94 117.23"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "107.89 116.5 105.38 116.3 102.85 116.09 100.33 115.89 100.32 109 103.41 111.77 105.03 114.63 107.89 114.86 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "107.89 116.5 105.35 116.29 102.83 116.09 100.33 115.89 100.32 109.07 103.39 111.84 105 114.66 107.89 114.89 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "107.89 116.5 105.31 116.29 102.81 116.09 100.33 115.89 100.32 109.15 103.38 111.92 104.97 114.69 107.89 114.92 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "107.89 116.5 105.28 116.29 102.8 116.09 100.33 115.89 100.32 109.22 103.36 111.99 104.94 114.72 107.89 114.95 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "107.89 116.5 105.25 116.28 102.78 116.09 100.33 115.89 100.32 109.29 103.35 112.06 104.91 114.75 107.89 114.99 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "107.89 116.5 105.21 116.28 102.77 116.08 100.33 115.89 100.32 109.37 103.33 112.14 104.88 114.78 107.89 115.02 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "107.89 116.5 105.18 116.28 102.75 116.08 100.33 115.89 100.32 109.44 103.32 112.21 104.85 114.81 107.89 115.05 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "107.89 116.5 105.15 116.28 102.73 116.08 100.33 115.89 100.32 109.51 103.3 112.28 104.82 114.85 107.89 115.09 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "107.89 116.5 105.11 116.27 102.72 116.08 100.33 115.89 100.32 109.59 103.29 112.35 104.79 114.88 107.89 115.12 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "107.89 116.5 105.08 116.27 102.7 116.08 100.33 115.89 100.32 109.66 103.27 112.42 104.75 114.91 107.89 115.15 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "107.89 116.5 105.05 116.27 102.68 116.08 100.33 115.89 100.32 109.73 103.26 112.5 104.72 114.94 107.89 115.19 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "107.89 116.5 105.02 116.27 102.67 116.08 100.33 115.89 100.32 109.81 103.24 112.57 104.69 114.97 107.89 115.22 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "107.89 116.5 104.98 116.26 102.65 116.08 100.33 115.89 100.32 109.88 103.23 112.64 104.66 115 107.89 115.25 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "107.89 116.5 104.95 116.26 102.63 116.07 100.33 115.89 100.32 109.95 103.21 112.72 104.63 115.03 107.89 115.29 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "107.89 116.5 104.92 116.26 102.62 116.07 100.33 115.89 100.32 110.03 103.2 112.79 104.6 115.06 107.89 115.32 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "107.89 116.5 104.88 116.26 102.6 116.07 100.33 115.89 100.32 110.1 103.18 112.86 104.57 115.09 107.89 115.35 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "107.89 116.5 104.85 116.25 102.58 116.07 100.33 115.89 100.32 110.17 103.17 112.93 104.54 115.12 107.89 115.39 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "107.89 116.5 104.82 116.25 102.57 116.07 100.33 115.89 100.32 110.25 103.15 113 104.51 115.15 107.89 115.42 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "107.89 116.5 104.78 116.25 102.55 116.07 100.33 115.89 100.32 110.32 103.14 113.08 104.48 115.18 107.89 115.45 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "107.89 116.5 104.75 116.25 102.54 116.07 100.33 115.89 100.32 110.39 103.12 113.15 104.45 115.21 107.89 115.49 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "107.89 116.5 104.72 116.24 102.52 116.06 100.33 115.89 100.32 110.47 103.1 113.22 104.42 115.24 107.89 115.52 107.89 116.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "107.89 116.5 104.69 116.24 102.5 116.06 100.33 115.89 100.32 110.54 103.09 113.3 104.39 115.28 107.89 115.55 107.89 116.5"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "183.36 8.8 183.35 111.79 104.51 119.71 99.31 118.72 104.37 0.01 104.37 0 183.36 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "104.34 115.13 180.55 107.91 180.56 11.8 104.35 4.01 104.34 115.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "179.89 12.74 179.88 106.96 145.43 110.15 144.67 110.22 105.22 113.88 105.26 4.53 144.68 8.87 145.44 8.95 179.89 12.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "145.44 8.95 145.43 110.15 144.67 110.22 144.68 8.87 145.44 8.95"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "177.96 13.17 183.13 13.62 183.13 9.71 177.96 9.22 177.96 13.17"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "180.56 9.37 183.39 9.64 183.39 13.74 180.56 13.49 180.56 9.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "177.96 13.17 183.13 13.62 183.13 9.71 177.96 9.22 177.96 13.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "177.96 11.6 183.13 12.07 183.13 9.71 177.96 9.22 177.96 11.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "178.76 12.54 180.83 12.73 180.83 10.12 178.76 9.92 178.76 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "180.55 100.94 183.38 100.71 183.38 104.81 180.55 105.06 180.55 100.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.18 105.2 183.36 104.74 183.36 100.82 178.18 101.25 178.18 105.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "178.7 104.62 180.77 104.44 180.77 101.83 178.7 102 178.7 104.62"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "177.75 79.7 180.55 79.59 180.55 79.05 183.13 78.95 183.13 75.04 179.9 75.14 177.95 75.2 177.75 79.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "180.55 75.02 183.38 74.94 183.38 79.04 180.55 79.15 180.55 75.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "180.56 35.38 183.38 35.51 183.38 39.61 180.56 39.51 180.56 35.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.07 39.29 183.25 39.48 183.25 35.57 178.07 35.34 178.07 39.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "178.83 38.68 180.9 38.76 180.9 36.15 178.83 36.06 178.83 38.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "178.83 38.68 180.9 38.76 180.9 36.15 178.83 36.06 178.83 38.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "178.83 38.68 180.9 38.76 180.9 36.15 178.83 36.06 178.83 38.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.29 79.02 183.36 78.83 183.35 75.06 178.11 75.24 178.29 79.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "179.02 78.34 181.09 78.32 180.97 75.71 178.89 75.72 179.02 78.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "179.02 78.34 181.09 78.32 180.97 75.71 178.89 75.72 179.02 78.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "179.02 78.34 181.09 78.32 180.97 75.71 178.89 75.72 179.02 78.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 24.35 176.93 26.12 175.8 24.35 150.01 22.65 148.76 24.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 16.39 176.93 18.57 175.8 20.18 150.01 18.27 148.76 16.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "150.01 22.65 150.01 18.27 148.76 16.39 148.76 24.35 150.01 22.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "176.93 26.12 175.8 24.35 175.8 20.18 176.93 18.57 176.93 26.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 52.21 176.93 52.55 175.8 50.84 150.01 50.44 148.76 52.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 44.25 176.93 45 175.8 46.67 150.01 46.06 148.76 44.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "150.01 50.44 150.01 46.06 148.76 44.25 148.76 52.21 150.01 50.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "176.93 52.55 175.8 50.84 175.8 46.67 176.93 45 176.93 52.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 70.97 176.93 70.35 175.8 68.68 150.01 69.16 148.76 70.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 63.01 176.93 62.8 175.8 64.5 150.01 64.78 148.76 63.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "150.01 69.16 150.01 64.78 148.76 63.01 148.76 70.97 150.01 69.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "176.93 70.35 175.8 68.68 175.8 64.5 176.93 62.8 176.93 70.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 98.83 176.93 96.78 175.8 95.17 150 96.96 148.76 98.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "148.76 90.87 176.93 89.23 175.8 90.99 150 92.58 148.76 90.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "150 96.96 150 92.58 148.76 90.87 148.76 98.83 150 96.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "176.93 96.78 175.8 95.17 175.8 90.99 176.93 89.23 176.93 96.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 23.88 109.04 21.86 110.47 20.04 140.02 21.99 141.3 23.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 15.81 109.04 13.32 110.47 15.34 140.02 17.53 141.3 15.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "140.02 21.99 140.02 17.53 141.3 15.81 141.3 23.88 140.02 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "109.04 21.86 110.47 20.04 110.47 15.34 109.04 13.32 109.04 21.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 52.12 109.03 51.73 110.47 49.84 140.01 50.29 141.3 52.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 44.05 109.03 43.19 110.47 45.14 140.01 45.83 141.3 44.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "140.01 50.29 140.01 45.83 141.3 44.05 141.3 52.12 140.01 50.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "109.03 51.73 110.47 49.84 110.47 45.14 109.03 43.19 109.03 51.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 71.14 109.03 71.84 110.47 69.9 140.01 69.35 141.3 71.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 63.07 109.03 63.31 110.47 65.21 140.01 64.89 141.3 63.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "140.01 69.35 140.01 64.89 141.3 63.07 141.3 71.14 140.01 69.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "109.03 71.84 110.47 69.9 110.47 65.21 109.03 63.31 109.03 71.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 99.37 109.03 101.72 110.46 99.7 140.01 97.65 141.3 99.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "141.3 91.3 109.03 93.18 110.46 95.01 140.01 93.19 141.3 91.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "140.01 97.65 140.01 93.19 141.3 91.3 141.3 99.37 140.01 97.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "109.03 101.72 110.46 99.7 110.46 95.01 109.03 93.18 109.03 101.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "104.51 119.71 99.31 118.72 0.09 100.12 0 19.95 104.37 0.01 104.51 119.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.61 114.56 98.61 114.19 95.87 113.67 91.19 112.8 88.43 112.28 83.75 111.4 80.99 110.89 76.31 110.01 73.55 109.5 68.87 108.62 66.11 108.11 61.43 107.23 58.68 106.71 53.99 105.84 51.24 105.32 46.55 104.45 43.81 103.93 39.13 103.06 36.37 102.54 31.69 101.66 28.93 101.15 24.25 100.27 21.5 99.76 16.81 98.88 14.06 98.36 9.37 97.49 6.62 96.97 4.31 96.54 4.23 23.06 6.62 22.61 9.37 22.1 14.06 21.22 16.81 20.7 21.5 19.82 24.25 19.31 28.93 18.43 31.69 17.91 36.37 17.04 39.13 16.52 43.81 15.64 46.55 15.13 51.24 14.25 53.99 13.73 58.68 12.86 61.43 12.34 66.11 11.46 68.87 10.95 73.55 10.07 76.31 9.55 80.99 8.67 83.75 8.16 88.43 7.28 91.19 6.76 95.87 5.89 98.61 5.37 100.49 5.02 100.61 114.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "0.7 23.13 0.13 22.88 0.14 23.6 0.7 23.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "9.33 22.1 9.33 97.49 6.6 96.97 6.6 22.61 9.33 22.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "16.7 20.7 16.7 98.88 13.97 98.36 13.97 21.22 16.7 20.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "24.07 19.31 24.07 100.27 21.34 99.76 21.34 19.82 24.07 19.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "31.44 17.91 31.44 101.66 28.71 101.15 28.71 18.43 31.44 17.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "38.81 16.52 38.81 103.06 36.08 102.54 36.08 17.04 38.81 16.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "46.17 15.13 46.17 104.45 43.45 103.93 43.45 15.64 46.17 15.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "53.54 13.73 53.54 105.84 50.81 105.32 50.81 14.25 53.54 13.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "60.91 12.34 60.91 107.23 58.18 106.71 58.18 12.86 60.91 12.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "68.28 10.95 68.28 108.62 65.55 108.11 65.55 11.46 68.28 10.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "75.65 9.55 75.65 110.01 72.92 109.5 72.92 10.07 75.65 9.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "83.02 8.16 83.02 111.4 80.29 110.89 80.29 8.67 83.02 8.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "90.39 6.76 90.39 112.8 87.66 112.28 87.66 7.28 90.39 6.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "97.75 5.37 97.75 114.19 95.03 113.67 95.03 5.89 97.75 5.37"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "107.39 6.42 100.58 5.82 100.58 1.28 107.39 1.93 107.39 6.42"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "104 1.5 100.24 1.14 100.23 5.9 104 6.23 104 1.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.39 6.42 100.58 5.82 100.58 1.28 107.39 1.93 107.39 6.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "105.99 5.62 103.28 5.38 103.28 2.38 105.99 2.63 105.99 5.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "104.34 107.97 100.58 108.27 100.58 113.03 104.34 112.7 104.34 107.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.59 112.31 100.78 112.92 100.78 108.38 107.59 107.83 107.59 112.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "106.6 111.63 103.89 111.87 103.89 108.87 106.6 108.65 106.6 111.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "106.6 111.63 103.89 111.87 103.89 108.87 106.6 108.65 106.6 111.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "106.6 111.63 103.89 111.87 103.89 108.87 106.6 108.65 106.6 111.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "104.35 78.49 100.58 78.61 100.58 83.37 104.35 83.22 104.35 78.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.67 82.97 100.86 83.24 100.86 78.7 107.67 78.49 107.67 82.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "106.6 82.27 103.89 82.37 103.89 79.37 106.6 79.28 106.6 82.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "106.6 82.27 103.89 82.37 103.89 79.37 106.6 79.28 106.6 82.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "106.6 82.27 103.89 82.37 103.89 79.37 106.6 79.28 106.6 82.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "104.35 33.65 100.59 33.47 100.59 38.24 104.35 38.38 104.35 33.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.59 38.39 100.78 38.14 100.78 33.6 107.59 33.91 107.59 38.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "106.01 37.55 103.3 37.44 103.3 34.45 106.01 34.56 106.01 37.55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvhc);
export default __webpack_public_path__ + "static/media/DVHC.ba0ae410b3fdb37d8d8de5878c31e2e9.svg";
export { ForwardRef as ReactComponent };